import React, { useEffect, useRef, useState } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/AttractionDetail/Index";
import ApiCall from "../common/ApiCall";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import HomeIcon from "../components/Iocns/HomeIcon";
import { getLangBySlug, getSlugByLang, getSlugNameByLang } from "../common/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/user/user.action";

export default function AttractionDetailController() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [locationName, setLocationName] = useState(searchParams.get("location") || "");
    const [productList, setProductList] = useState([]);
    const [attractionDetail, setAttractionDetail] = useState({});
    const [locationDetail, setLocationDetail] = useState(null);

    const navigate = useNavigate()
    const perems = useParams();
    const { slug } = useParams();
    const [attractionNextPageUrl, setAttractionNextPageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isAttractionLoading, setIsAttractionLoading] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const descriptionRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const location = useLocation()
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const slugLang = getSlugByLang(user?.language)


    const getAttractionPageList = async (type = 'ALL', page = null) => {

        var slugField = "";
        let lang = getLangBySlug(perems?.lang)
        slugField = getSlugNameByLang(lang)
        if (user?.language != lang) {
            dispatch(setLanguage(lang))
        }

        let data = {}
        data.type = type;
        data.page = page;
        data.attraction = perems?.slug;
        data.field = slugField
        if (locationName) {
            data.locationSlug = locationName
        }

        if (attractionDetail && attractionDetail?.id) {
            data.id = attractionDetail?.id;
        }

        if (locationDetail && locationDetail?.id) {
            data.locationId = locationDetail?.id;
        }


        if (type == 'ALL') {
            setIsLoading(true)
        }
        if (type == 'products') {
            setIsAttractionLoading(true)
        }

        const getList = await ApiCall('post', 'attraction-page-list', data)
        setIsLoading(false)
        setIsAttractionLoading(false)


        if (getList) {

            if (getList?.data?.success) {
                if (type == 'ALL') {
                    setProductList(getList.data.data.productList)
                    setAttractionDetail(getList.data.data.details)
                    if (getList?.data?.data?.locationDetail) {
                        setLocationDetail(getList.data.data.locationDetail)
                    } else {
                        setLocationDetail(null)
                    }
                    setAttractionNextPageUrl(getList.data.data.product_list_next_page_url)
                    setBreadcrumbList([
                        {
                            name: <HomeIcon />,
                            url: "/" + slugLang
                        },
                        {
                            name: "Attraction",

                        },
                        {
                            name: getList?.data?.data?.details?.name,
                        },

                    ])
                }

                if (type == 'products') {
                    setProductList(prevProducts => [...prevProducts, ...getList.data.data.productList]);
                    setAttractionNextPageUrl(getList.data.data.product_list_next_page_url)
                }


            } else {
                // navigate(-1)
            }
        } else {
            // navigate(-1)
        }
    }

    useEffect(() => {
        (async () => {
            if (perems?.slug) {
                await getAttractionPageList('ALL', null)

            }
        })();
    }, [perems?.slug, locationName]);


    const onClickLoadMore = async (type, page) => {
        await getAttractionPageList(type, page)
    }

    useEffect(() => {
        // Check if the script is already loaded to avoid loading it multiple times

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup: Remove the script when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, [productList]);

    useEffect(() => {
        if (descriptionRef.current) {
            setIsOverflowing(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
        }
    }, [attractionDetail?.description]);

    // useEffect(() => {



    //     if (attractionDetail?.slug && (location?.pathname?.split("/")?.pop() != attractionDetail.slug)) {
    //         let newurl = '/attraction/' + attractionDetail.slug
    //         window.history.replaceState(null, "", newurl);


    //     }






    // }, [location.pathname, attractionDetail]);


    //     useEffect(() => {

    //         if (user?.language != "Other") {

    //             const slugField = getSlugNameByLang(user?.language)
    //             const slugLang = getSlugByLang(user?.language)

    //             if (slugField && attractionDetail?.[slugField]) {
    //                 window.history.replaceState(null, "", (slugLang ? ('/' + slugLang) : '') + '/attraction/' + attractionDetail?.[slugField]);
    //             }
    //         }

    //         return () => {
    //             console.log('cleanup');
    //         };

    //     }, [user?.language, attractionDetail]);


    useEffect(() => {
        if (!attractionDetail) return;

        const currentSlug = location?.pathname?.split("/")?.pop();
        const defaultSlug = attractionDetail?.slug;
        const userLang = user?.language;

        if (userLang && userLang !== "Other") {
            const slugField = getSlugNameByLang(userLang);
            // const slugLang = getSlugByLang(userLang);

            if (slugField && attractionDetail?.[slugField]) {
                const newUrl = `${slugLang ? '/' + slugLang : ''}/attraction/${attractionDetail[slugField]}${locationName ? '?location=' + locationDetail[slugField] : ''}`;
                window.history.replaceState(null, "", newUrl);
            }
        } else if (defaultSlug && currentSlug !== defaultSlug) {
            const newUrl = ('/' + slugLang) + `/attraction/${defaultSlug}${locationName ? '?location=' + locationName : ''}`;
            window.history.replaceState(null, "", newUrl);
        }

        return () => {
            console.log('cleanup');
        };
    }, [location.pathname, attractionDetail, user?.language, locationName]);

    return (
        <>
            <PageTitle
                title={attractionDetail?.meta_title ?? undefined}
                metaTitle={attractionDetail?.meta_title ?? undefined}
                metaKeyword={attractionDetail?.meta_keyword ?? undefined}
                metaDescription={attractionDetail?.meta_description ?? undefined}
            />
            <Index
                attractionDetail={attractionDetail}
                productList={productList}
                isLoading={isLoading}
                attractionNextPageUrl={attractionNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionLoading={isAttractionLoading}
                locationDetail={locationDetail}
                expanded={expanded}
                setExpanded={setExpanded}
                descriptionRef={descriptionRef}
                isOverflowing={isOverflowing}
                breadcrumbList={breadcrumbList}


            />
        </>
    )
}